module.exports = __webpack_public_path__ + "assets/acd6660e87fd16ef92f3b6a00bd0e4dc.mp4";